import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Truck } from "lucide-react";
import { useSEO, siteUrl } from "@/lib/seo";

const NotFound = () => {
  // Set noindex,nofollow via useSEO so the robots meta is reset to the
  // default index,follow on the next page render. This avoids any DOM-leak
  // of noindex into valid public routes.
  useSEO({
    title: "404 — Pagina niet gevonden | Wasz.nl",
    description: "De pagina die u zoekt bestaat niet of is verplaatst. Ga terug naar de homepage.",
    canonical: siteUrl("/"),
    robots: "noindex,nofollow",
  });

  return (
    <main className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center">
        <div className="w-16 h-16 rounded-2xl bg-[#00D4FF] flex items-center justify-center mx-auto mb-8">
          <Truck className="w-8 h-8 text-[#050509]" />
        </div>
        <p className="section-overline mb-3">404</p>
        <h1 className="text-5xl font-black text-white tracking-tighter mb-4">Verkeerde afslag.</h1>
        <p className="text-white/55 max-w-md mx-auto mb-8">
          De pagina die u zocht is niet gevonden. Onze planning is wel bereikbaar.
        </p>
        <Link to="/">
          <button className="btn-primary inline-flex" data-testid="404-back-home">
            <ArrowLeft className="w-4 h-4" /> Terug naar home
          </button>
        </Link>
      </div>
    </main>
  );
};

export default NotFound;
